// src/config/payoutProviderConfig.js
import { SAVE_MERCHANT_PAYOUT_MASTER, SAVE_SURYODAY_PAYOUT_MASTER, SAVE_VIMO_PAYOUT_MASTER } from "./constant";

export const payoutProviderConfig = {
    Decentro: {
        apiUrl: SAVE_MERCHANT_PAYOUT_MASTER,
        fields: [
            { name: "accountsModuleSecrete", label: "Account Module Secret", required: true },
            { name: "clientIds", label: "Client ID", required: true },
            { name: "clientSecrete", label: "Client Secret", required: true },
            { name: "ifsc", label: "IFSC", required: true, type: "ifsc" },
            { name: "mvaCustomerId", label: "MVA Customer ID", required: true },
            { name: "masterAliusId", label: "Master Alius ID", required: true },
            { name: "masterVirtualAccount", label: "Master Virtual Account", required: true },
            { name: "userName", label: "User Name", required: true },
            { name: "providerSecrete", label: "Provider Secret", required: true },
            { name: "paymentModuleSecrete", label: "Payment Module Secret", required: true },
            { name: "password", label: "Password", required: true, type: "password" },
            { name: "mvaMobileNumber", label: "MVA Mobile Number", required: true, type: "mobile" },
        ],

        payload: (f, g) => ({
            ...f,
            mid: g.mid,
            masterMerchantId: g.masterMerchantId,
            vehicleMasterId: g.vehicle,
            paymentProvider: "Decentro",
            transferType: g.transferType,
        }),
    },

    Finzen: {
        apiUrl: SAVE_MERCHANT_PAYOUT_MASTER,
        fields: [
            { name: "apiKey", label: "API Key", required: true },
            { name: "secreteKey", label: "Secret Key", required: true },
            { name: "MerchantEmail", label: "Merchant Email", required: true },
        ],
        payload: (f, g) => ({
            ...f,
            mid: g.mid,
            masterMerchantId: g.masterMerchantId,
            vehicleMasterId: g.vehicle,
            paymentProvider: "Finzen",
            transferType: g.transferType,
        }),
    },

    BranchX: {
        apiUrl: SAVE_MERCHANT_PAYOUT_MASTER,
        fields: [
            { name: "apiKey", label: "API Key", required: true },
            { name: "secreteKey", label: "Secret Key", required: true },
            { name: "bankName", label: "Bank Name", required: true },
        ],
        payload: (f, g) => ({
            ...f,
            mid: g.mid,
            masterMerchantId: g.masterMerchantId,
            vehichleMasterId: g.vehicle,
            paymentProvider: "BranchX",
            transferType: g.transferType,
        }),
    },

    Paywings: {
        apiUrl: SAVE_MERCHANT_PAYOUT_MASTER,
        fields: [
            { name: "apiKey", label: "API Key", required: true }
        ],
        payload: (f, g) => ({
            ...f,
            mid: g.mid,
            masterMerchantId: g.masterMerchantId,
            vehicleMasterId: g.vehicle,
            paymentProvider: "Paywings",
            transferType: g.transferType,
        }),
    },

    Suryoday: {
        apiUrl: SAVE_SURYODAY_PAYOUT_MASTER,

        fields: [
            { name: "secretKey", label: "Secret Key", required: true },
            { name: "authToken", label: "Auth Token", required: true },

            { name: "bankName", label: "Bank Name", required: true },
            { name: "bankOnboardedMid", label: "Bank Onboarded Mid", required: true },

            { name: "loginUsername", label: "Login Username", required: true },
            { name: "loginPassword", label: "Login Password", required: true, type: "password" },

            // Payment Provider (readonly)
            { name: "paymentProvider", label: "Payment Provider", readonly: true, defaultValue: "Suryoday" },

            // Another secret key (in screenshot)
            { name: "signingSecretKey", label: "Secret Key", required: true },

            { name: "username", label: "Username", required: true },
            { name: "password", label: "Password", required: true, type: "password" },

            { name: "vpa", label: "Vpa", required: true }
        ],

        payload: (f, g) => ({
            apiKey: f.apiKey,
            secretKey: f.secretKey,
            authToken: f.authToken,

            bankName: f.bankName,
            bankOnboardedMid: f.bankOnboardedMid,

            loginUsername: f.loginUsername,
            loginPassword: f.loginPassword,

            paymentProvider: "Suryoday",
            signingSecretKey: f.signingSecretKey,

            username: f.username,
            password: f.password,
            vpa: f.vpa,

            mid: g.mid,
            masterMerchantId: g.masterMerchantId,
            vehicleMasterId: g.vehicle,
            transferType: g.transferType,
            max_txn_amt: 0,
            paymentModuleSecret: "",
        })
    },

    Vimo: {
        apiUrl: SAVE_VIMO_PAYOUT_MASTER,
        fields: [
            { name: "bankName", label: "Bank Name", required: true },
            { name: "encryptedDecryptedKey", label: "Encrypted/Decrypted Key", required: true },
            { name: "password", label: "Password", required: true, type: "password" },
            { name: "registeredNumber", label: "Registered Mobile Number", required: true, type: "mobile" },
            { name: "saltKey", label: "Salt Key", required: true },
            { name: "secretKey", label: "Secret Key", required: true },
            { name: "username", label: "Username", required: true },
        ],

        payload: (f, g) => ({
            ...f,
            mid: g.mid,
            masterMerchantId: g.masterMerchantId,
            vehicleMasterId: g.vehicle,
            paymentProvider: "Vimo",
            transferType: g.transferType,
            max_txn_amt: 0,
        }),
    },
};